import type { Action } from 'redux';

const defaultState: string[] = [];

const RESET = 'tealium/addOnAdProductNames/RESET';
const UPDATE = 'tealium/addOnAdProductNames/UPDATE';

export interface ResetAction extends Action {
  type: typeof RESET;
}

export interface UpdateAction extends Action {
  type: typeof UPDATE;
  value: string[];
}

export const actionResetAddOnAdProductNames = () => ({
  type: RESET,
});

export const actionUpdateAddOnAdProductNames = (value: string[]) => ({
  type: UPDATE,
  value,
});

export default (
  state: State = defaultState,
  action: UpdateAction | ResetAction,
) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
